require('./RASustainabilityModal.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

//@components
const OKModal = require('commonsComponents/OKModal');

// @actions
const suitabilityActions = require('../../../actions/RASuitabilityTest');

//@utilidades
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_RA_SUITABILITY_TEST } = require('utilities/tagging');

//@constants
const {
    SUITABILITY_TEST_MODAL_QUESTION_500,
} = require('../../../raConstants/index');

class RASustainabilityModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleConfirmButton = this.handleConfirmButton.bind(this);
        this.handleAfterOpenModal = this.handleAfterOpenModal.bind(this);
        this.handleClickReview = this.handleClickReview.bind(this);
        this.handleClickContinue = this.handleClickContinue.bind(this);
        this.handleClickClose = this.handleClickClose.bind(this);
        this.getAnswerOne = this.getAnswerOne.bind(this);
        this.buildDescription = this.buildDescription.bind(this);
    }

    handleConfirmButton(answer) {
        const {
            sendTest,
            history,
            immWizard,
            setSustainabiltyOurStrategies,
            sendLogs,
        } = this.props;
        const totalAnswers = immWizard.get('totalAnswers') + 1;
        setSustainabiltyOurStrategies(answer);
        sendTest(history, true, totalAnswers);
        sendLogs(SUITABILITY_TEST_MODAL_QUESTION_500);
        this.props.showModalNewQuestions(false);
    }

    handleAfterOpenModal() {
        taggingEventHandled(PROC_RA_SUITABILITY_TEST, 'openModalQ500');
    }

    getAnswerOne() {
        const { immSuitabilityTest } = this.props;
        const immQuestions = immSuitabilityTest.get('questions');
        const answers500 = immQuestions.getIn(['500', 'answers']).toJS();
        return answers500[0].id;
    }

    handleClickReview() {
        const { sendLogs, setSustainabiltyOurStrategies } = this.props;
        setSustainabiltyOurStrategies(this.getAnswerOne());
        sendLogs(SUITABILITY_TEST_MODAL_QUESTION_500);
        taggingEventHandled(PROC_RA_SUITABILITY_TEST, 'reviewModalQ500');
        this.props.showModalNewQuestions(false);
    }

    handleClickContinue(text) {
        taggingEventHandled(PROC_RA_SUITABILITY_TEST, 'continueModalQ500');
        this.handleConfirmButton(text);
    }

    handleClickClose() {
        const { setSustainabiltyOurStrategies, sendLogs } = this.props;
        setSustainabiltyOurStrategies(this.getAnswerOne());
        sendLogs(SUITABILITY_TEST_MODAL_QUESTION_500);
        taggingEventHandled(PROC_RA_SUITABILITY_TEST, 'closeModalQ500');
        this.props.showModalNewQuestions(false);
    }

    buildDescription() {
        const { immSuitabilityTest } = this.props;
        const immQuestions = immSuitabilityTest.get('questions');
        const descriptionQuestion500 = immQuestions.getIn([
            '500',
            'description',
        ]);
        const paragraphOne = descriptionQuestion500.split('\n')[0];
        const paragraphTwo = descriptionQuestion500.split('\n')[1];

        return (
            <div>
                <p>{paragraphOne}</p>
                <p>{paragraphTwo}</p>
            </div>
        );
    }

    render() {
        const { immSuitabilityTest, showModalNewQuestions } = this.props;
        const openModal = immSuitabilityTest.get('showModalForNewQuestions');
        const immQuestions = immSuitabilityTest.get('questions');
        const descriptionQuestion500 = this.buildDescription();
        const answers500 = immQuestions.getIn(['500', 'answers']).toJS();
        const titleModal = immQuestions.getIn(['500', 'title']);
        return (
            <div>
                <OKModal
                    isOpen={openModal}
                    size="regular"
                    onAfterOpen={this.handleAfterOpenModal}
                    headerType="custom"
                    title={titleModal}
                    titleAlignment="center"
                    description={descriptionQuestion500}
                    descriptionAlignment="left"
                    handleCloseModal={() => showModalNewQuestions(false)}
                    footerType="navigation"
                    onCloseCallback={this.handleClickClose}
                    onPrimaryButtonClick={() =>
                        this.handleClickContinue(answers500[1].id)
                    }
                    primaryButtonText={answers500[1].label.title}
                    onSecondaryButtonClick={this.handleClickReview}
                    secondaryButtonText={answers500[0].label.title}
                    shouldCloseOnOverlayClick={false}
                />
            </div>
        );
    }
}

RASustainabilityModal.propTypes = {
    immSuitabilityTest: PropTypes.object.isRequired,
    immWizard: PropTypes.object.isRequired,
    showModalNewQuestions: PropTypes.func.isRequired,
    sendTest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    setSustainabiltyOurStrategies: PropTypes.func.isRequired,
    sendLogs: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immSuitabilityTest: state.raSuitabilityTest,
        immWizard: state.raWizard,
    }),
    {
        sendTest: suitabilityActions.sendTest,
        sendLogs: suitabilityActions.sendLogs,
        showModalNewQuestions: suitabilityActions.showModalNewQuestions,
        setSustainabiltyOurStrategies:
            suitabilityActions.setSustainabiltyOurStrategies,
    },
)(withRouter(RASustainabilityModal));
